import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { IntegrationHeader, PageContent } from 'components/organisms/module-settings/integrations/components';
import { SettingsPage } from 'routes/settings/setting-page-layout-style';
export const IntegrationPageTemplate = ({ title, icon, breadcrumbLink, breadcrumbText, children, subText, learnMoreLink, disableBreadcrumb })=>{
    return /*#__PURE__*/ _jsxs(SettingsPage, {
        children: [
            /*#__PURE__*/ _jsx(IntegrationHeader, {
                disableBreadcrumb: disableBreadcrumb,
                title: title,
                icon: icon,
                breadcrumbLink: breadcrumbLink,
                breadcrumbText: breadcrumbText,
                subText: subText,
                learnMoreLink: learnMoreLink ? /*#__PURE__*/ _jsx("a", {
                    href: learnMoreLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "learn_more_with_dots"
                    })
                }) : null
            }),
            /*#__PURE__*/ _jsx(PageContent, {
                children: /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        xl: {
                            span: 16,
                            offset: 4
                        },
                        span: 16,
                        offset: 4,
                        children: children
                    })
                })
            })
        ]
    });
};
